import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { PermissionService } from '../../core/services/permission.service';
import { SettingsService } from '../../core/services/settings.service';
import { NavItem } from '../../core/permissions';
import { getNavIconPaths } from '../../core/nav-icons';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  isSidebarOpen = false;
  currentUser: any = null;
  mainNavItems: NavItem[] = [];
  settingsNavItems: NavItem[] = [];
  private routerSubscription?: Subscription;
  private authSubscription?: Subscription;
  private isMobile = false;

  constructor(
    private authService: AuthService,
    private permissionService: PermissionService,
    private router: Router,
    public settingsService: SettingsService
  ) {
    this.checkMobileView();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkMobileView();
    // If window is resized to desktop size, close sidebar
    if (!this.isMobile && this.isSidebarOpen) {
      this.isSidebarOpen = false;
    }
  }

  ngOnInit(): void {
    this.authSubscription = this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
      this.refreshNavItems();
    });
    this.authService.permissions$.subscribe(() => this.refreshNavItems());
    this.refreshNavItems();

    if (this.authService.isAuthenticated()) {
      this.authService.refreshSession().subscribe();
    }

    // Close sidebar on mobile when route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.isMobile && this.isSidebarOpen) {
          this.isSidebarOpen = false;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private checkMobileView(): void {
    this.isMobile = window.innerWidth < 768; // md breakpoint in Tailwind
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  logout(): void {
    this.authService.logout();
  }

  isActive(route: string): boolean {
    return this.router.url === route || this.router.url.startsWith(route + '/');
  }

  getNavIconPaths(icon: string): string[] {
    return getNavIconPaths(icon);
  }

  private refreshNavItems(): void {
    const items = this.permissionService.getNavItems();
    this.mainNavItems = items.filter((item) => item.section !== 'settings');
    this.settingsNavItems = items.filter((item) => item.section === 'settings');
  }
}












